<script setup lang="ts">
const { isSandbox } = defineProps<{
  isSandbox?: boolean
}>()
</script>

<template>
  <div class="flex min-h-dvh flex-col">
    <TheHeader :is-sandbox>
      <slot name="header" />
      <template #right>
        <slot name="header-right" />
      </template>
    </TheHeader>
    <main class="flex min-h-0 grow flex-col scroll-smooth">
      <div class="min-h-0 grow">
        <slot />
      </div>
      <slot name="footer" />
    </main>
  </div>
</template>
